import { render, staticRenderFns } from "./LoginSocial.vue?vue&type=template&id=4a804a75&scoped=true"
import script from "./LoginSocial.vue?vue&type=script&lang=js"
export * from "./LoginSocial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a804a75",
  null
  
)

export default component.exports